import React, { useEffect } from 'react'

const Pills = ({ data }) => {
  console.log('PILLS DATA', data)
  const pillStyle = 'flex w-28 py-1 px-4 rounded-full justify-center'
  return (
    <div className="flex flex-col space-y-1 items-center">
      {data ? (
        data['status_code']?.toLowerCase() == 'active' ? (
          <div className={`${pillStyle} bg-green text-white`}>Active</div>
        ) : data['status_code']?.toLowerCase() == 'inactive' ? (
          <div className={`${pillStyle} bg-red text-white`}>Inactive</div>
        ) : (
          <div className={`${pillStyle} bg-orange text-white`}>In Review</div>
        )
      ) : (
        <div></div>
      )}
    </div>
  )
}

export default Pills
